import { ApiError } from './api.ts';

/** Turn anything thrown into a sentence worth showing a user. */
export function describeError(error: unknown): string {
  if (error instanceof ApiError) return error.message;
  if (error instanceof Error) return error.message;
  return 'Something went wrong. Try again.';
}

/** Field-level messages from a 422, keyed by field name. */
export function fieldErrors(error: unknown): Record<string, string> {
  if (!(error instanceof ApiError) || !Array.isArray(error.details)) return {};
  return Object.fromEntries(
    error.details
      .filter(
        (detail): detail is { field: string; message: string } =>
          typeof detail === 'object' && detail !== null && 'field' in detail && 'message' in detail,
      )
      .map((detail) => [detail.field, detail.message]),
  );
}

/**
 * Which plan allowance a 402 hit, or null if this was not a plan limit.
 *
 * Lets a screen offer the upgrade rather than only reporting the refusal —
 * being told you cannot invite anyone is less useful than being told why and
 * where to fix it.
 */
export function planLimit(error: unknown): string | null {
  if (!(error instanceof ApiError) || error.code !== 'payment_required') return null;
  const details = error.details;
  if (typeof details !== 'object' || details === null || !('limit' in details)) return null;
  const limit = (details as { limit: unknown }).limit;
  return typeof limit === 'string' ? limit : null;
}
